import { Box, Button, Grid, Paper, Typography } from '@mui/material'
import React from 'react'
import notFoundImg from "../../../assets/images/notFound.png"
import useStyles from '../../noNetwork/style'
import { useNavigate } from 'react-router-dom'
const PageNotFound = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const token = localStorage.getItem("token")
const goToHome = () => {
  if(token){
    navigate('/dashboard')
  }else{
    navigate('/')
  }
}
  return (
    <Box className={classes.errorImageBox}>
    <img className={classes.errorImage} src={notFoundImg} alt='error-404-image'/>
    <Grid className={classes.errorTextGrid} container direction="column" alignItems="center">
        <Grid item>
            <Typography className={classes.errorHeading} variant="h5">
                OOPS, PAGE N<span style={{color:'#dc1a5c'}}>O</span>T FOUND!</Typography>
        </Grid>
        <Grid item>
            <Typography className={classes.errorBody} variant="body1">
                Sorry but the page you are looking for does not exist, have been removed,
                name changed or is temporarily unavailable.
            </Typography>
            <Button variant='contained' sx={{marginBlock:2}} onClick={goToHome}>Go To Home</Button>
        </Grid>
    </Grid>
</Box>
    )
}

export default PageNotFound